/* CoThings — Meilisearch storefront search.
 * Two features, both talking to the Meilisearch REST API with a SEARCH-ONLY key:
 *   1) Instant autocomplete dropdown on the header search inputs.
 *   2) A faceted results page (enhances /search, native results as fallback).
 * No external libraries required (jQuery/Bootstrap are present but unused here).
 */
(function () {
  'use strict';

  var CFG = window.MEILI_CONFIG || {};
  if (!CFG.host || !CFG.key || !CFG.index) {
    console.warn('[meili] missing MEILI_CONFIG; search widget disabled');
    return;
  }
  var ENDPOINT = CFG.host.replace(/\/$/, '') + '/indexes/' + CFG.index + '/search';
  var SEARCH_URL = CFG.searchUrl || '/search';

  /* ---------- analytics tracking ---------- */
  var EVENTS_URL = CFG.eventsUrl || '';
  var SESSION = (function () {
    try {
      var s = sessionStorage.getItem('meili_sid');
      if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('meili_sid', s); }
      return s;
    } catch (e) { return null; }
  })();
  function track(ev) {
    if (!EVENTS_URL) return;
    try {
      ev.session = SESSION;
      var blob = new Blob([JSON.stringify(ev)], { type: 'text/plain' });
      if (navigator.sendBeacon) navigator.sendBeacon(EVENTS_URL, blob);
      else fetch(EVENTS_URL, { method: 'POST', body: JSON.stringify(ev), keepalive: true });
    } catch (e) { /* never break search on analytics */ }
  }
  // Delegated click tracking for any product link we render (capture phase so it
  // fires before navigation; sendBeacon still delivers during unload).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-pid]');
    if (!a) return;
    track({
      type: 'click', query: a.getAttribute('data-q') || '',
      productId: a.getAttribute('data-pid'), productTitle: a.getAttribute('data-title'),
      price: parseFloat(a.getAttribute('data-price')) || null,
      position: parseInt(a.getAttribute('data-pos'), 10) || null,
      source: a.getAttribute('data-src') || ''
    });
  }, true);

  /* ---------- helpers ---------- */
  // Match the theme's money format exactly: "{{amount}}0 DT" = 2 decimals with
  // comma thousands + a trailing 0 → always 3 decimals, e.g. "129.000 DT", "2,631.000 DT".
  function money(n) {
    if (n == null) return '';
    var p = Number(n).toFixed(2).split('.');
    return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1] + '0 DT';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Lowercase + strip accents, for relevance matching (alimentation ~ Alimentations).
  function norm(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  // Query completions/corrections: find the query phrase inside result titles and
  // return it plus the next couple of words, with the title's (correct) spelling.
  function completions(q, hits) {
    var qw = norm(q).split(/\s+/).filter(Boolean);
    if (!qw.length) return [];
    var out = [], seen = {};
    for (var i = 0; i < hits.length && out.length < 3; i++) {
      var words = (hits[i].title || '').split(/\s+/), nw = words.map(norm), start = -1;
      for (var j = 0; j + qw.length <= nw.length; j++) {
        var ok = true;
        for (var k = 0; k < qw.length; k++) {
          var last = k === qw.length - 1;
          if (last ? nw[j + k].indexOf(qw[k]) !== 0 : nw[j + k] !== qw[k]) { ok = false; break; }
        }
        if (ok) { start = j; break; }
      }
      if (start < 0) continue;
      var phrase = words.slice(start, start + qw.length + 2).join(' ').replace(/[,\u2013-]+$/, '').trim();
      var key = norm(phrase);
      if (phrase && !seen[key]) { seen[key] = 1; out.push(phrase); }
    }
    return out;
  }
  // Shopify CDN image resize: insert _<w>x before the file extension.
  function thumb(url, w) {
    if (!url) return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2');
  }
  // Aspect-ratio image box, self-contained (does NOT depend on the theme's
  // lazysizes JS). Marked lazyloaded so the theme's blur/opacity rules treat it
  // as already loaded, and inline-styled so sizing works without theme CSS.
  function imgBox(url, title, cls) {
    if (!url) return '<span class="image-lazysize" style="display:block;padding-top:100%;"></span>';
    return '<span class="image-lazysize" style="position:relative;display:block;padding-top:100%;">' +
      '<img class="' + cls + ' img-lazy lazyloaded" loading="lazy" src="' + esc(thumb(url, 540)) + '" alt="' + esc(title) + '"' +
      ' style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;">' +
      '</span>';
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }
  function request(body) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + CFG.key },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  // dd/mm/yyyy from a ms timestamp (availableAfterTs).
  function fmtDate(ts) {
    var d = new Date(ts);
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
  }
  // "24h" / "48h" / "N jours" — same wording as snippets/product-detail-stock.liquid.
  function delayText(days) {
    if (days === 1) return '24h';
    if (days === 2) return '48h';
    return days + ' jours';
  }
  function statusLine(cls, color, text) {
    return '<span class="' + cls + '" style="' + (color ? 'color:' + color + ';' : '') +
      'display:block;font-size:0.9em;">' + text + '</span>';
  }
  // Stock status, mirroring the product page and the theme's product cards so a
  // product reads the SAME everywhere. Three cases, in priority order:
  //   1. dated incoming shipment  -> "Bientôt en stock dès le dd/mm/yyyy"
  //   2. not sellable             -> "Epuisé"
  //   3. sellable but no stock    -> "Sur Commande (24h / 48h / N jours)"
  // Case 3 needs the index's `backorder` flag: continue-selling products are
  // available=true, so `available` alone cannot tell them from real stock.
  function statusHtml(hit) {
    if (hit.availableAfterTs && hit.availableAfterTs > Date.now())
      return statusLine('meili-ac-soon', '#e67e22', 'Bientôt en stock dès le ' + fmtDate(hit.availableAfterTs));
    if (!hit.available) return statusLine('meili-ac-oos', '', 'Epuisé');
    if (hit.backorder && hit.deliveryDays)
      return statusLine('meili-ac-soon', '#e67e22', 'Sur Commande (' + delayText(hit.deliveryDays) + ')');
    return '';
  }
  function priceHtml(hit) {
    var p = (hit.onSale && hit.compareAtPrice)
      // Sale price in red, original struck through in grey (matches the theme).
      ? '<span class="now">' + money(hit.price) + '</span><span class="was">' + money(hit.compareAtPrice) + '</span>'
      : money(hit.price);
    return p + statusHtml(hit);
  }

  /* ---------- cart + quote seeds (shared by dropdown AND results page) ---------- */
  // Product IDs the shopper has already shown intent on.
  function quoteSeedIds() {
    try { return (JSON.parse(localStorage.getItem('cothings_quote_items')) || []).map(function (i) { return String(i.product_id); }).filter(Boolean); }
    catch (e) { return []; }
  }
  function cartSeedIds() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (c) { return (c.items || []).map(function (i) { return String(i.product_id); }); })
      .catch(function () { return []; });
  }
  function idList(ids) { return ids.map(function (id) { return '"' + String(id).replace(/"/g, '\\"') + '"'; }).join(', '); }

  // Remember when each seed (cart/quote product) first appeared, so the most
  // recently added product can lead the recommendations. Newly seen ids get the
  // current time (later array position breaks ties); removed ids are pruned.
  var SEEN_KEY = 'meili_seed_seen';
  function updateSeedRecency(seedsInOrder) {
    var map;
    try { map = JSON.parse(localStorage.getItem(SEEN_KEY)) || {}; } catch (e) { map = {}; }
    var now = Date.now(), tick = 0, changed = false, cur = {};
    seedsInOrder.forEach(function (id) {
      if (map[id] == null) { map[id] = now + (tick++); changed = true; }
      cur[id] = map[id];
    });
    Object.keys(map).forEach(function (id) { if (cur[id] == null) { delete map[id]; changed = true; } });
    if (changed) { try { localStorage.setItem(SEEN_KEY, JSON.stringify(map)); } catch (e) { } }
    return cur; // id -> timestamp (higher = more recently added)
  }

  // Context for the "produits complémentaires" page: the co-purchase lead
  // (fbtIds, most-recent product first) + the seed CATEGORIES (so the page can
  // infinitely scroll same-category best-sellers). Returns { fbtIds, rank, seeds, types }.
  function relatedContext() {
    return cartSeedIds().then(function (cart) {
      var all = cart.concat(quoteSeedIds());
      var seeds = all.filter(function (v, i) { return v && all.indexOf(v) === i; });
      if (!seeds.length) return { fbtIds: [], rank: {}, seeds: [], types: [] };
      var recency = updateSeedRecency(seeds);
      return request({ q: '', filter: 'id IN [' + idList(seeds) + ']', limit: seeds.length,
        attributesToRetrieve: ['id', 'productType', 'frequentlyBoughtWith'] })
        .then(function (s) {
          var seedHits = s.hits || [];
          var byRecency = seedHits.slice().sort(function (a, b) { return (recency[String(b.id)] || 0) - (recency[String(a.id)] || 0); });
          var fbtIds = [], picked = {};
          byRecency.forEach(function (h) {
            (h.frequentlyBoughtWith || []).forEach(function (id) {
              id = String(id);
              if (seeds.indexOf(id) >= 0 || picked[id]) return;
              picked[id] = 1; fbtIds.push(id);
            });
          });
          var types = {}; seedHits.forEach(function (h) { if (h.productType) types[h.productType] = 1; });
          var rank = {}; fbtIds.forEach(function (id, i) { rank[id] = i; });
          return { fbtIds: fbtIds, rank: rank, seeds: seeds, types: Object.keys(types) };
        }).catch(function () { return { fbtIds: [], rank: {}, seeds: seeds, types: [] }; });
    });
  }

  /* ==================================================================
   * 1) AUTOCOMPLETE
   * ================================================================== */
  function initAutocomplete(input) {
    if (!input || input.dataset.meiliBound) return;
    input.dataset.meiliBound = '1';
    input.setAttribute('autocomplete', 'off');

    var box = document.createElement('div');
    box.className = 'meili-ac';
    box.setAttribute('role', 'listbox');
    // Place the dropdown relative to the input's positioned container.
    var anchor = input.closest('.searchbox') || input.closest('.container') || input.parentNode;
    (input.closest('form') ? input.closest('form').parentNode : anchor).appendChild(box);

    var activeIdx = -1, hits = [], lastQ = '';
    // Log a "search" event once the query settles (avoids logging every keystroke).
    var lastTotal = 0, lastLogged = '';
    var logSearch = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2 || q === lastLogged) return;
      lastLogged = q;
      track({ type: 'search', query: q, results: lastTotal, source: 'dropdown' });
    }, 1100);

    function close() { box.classList.remove('is-open'); activeIdx = -1; }
    function open() { box.classList.add('is-open'); }

    // Two-column panel like Searchanise: suggestions (left, ALWAYS shown) +
    // scrollable product GRID (right) + "Afficher tous" button under suggestions.
    var POP_TERMS = ['arduino uno', 'esp32', 'batterie lithium', 'ruban led', 'fer a souder', 'raspberry pi', 'moteur', 'capteur'];
    var popularCache = null;

    function gridCard(h, i, q) {
      var title = (h._formatted && h._formatted.title) || esc(h.title);
      var badge = (h.onSale && h.discountPct) ? '<span class="meili-gbadge">-' + h.discountPct + '%</span>' : '';
      return '<a class="meili-gcard" role="option" href="' + esc(h.url) + '"' +
        ' data-pid="' + esc(h.id) + '" data-title="' + esc(h.title) + '" data-price="' + (h.price == null ? '' : h.price) + '"' +
        ' data-pos="' + (i + 1) + '" data-q="' + esc(q || '') + '" data-src="dropdown">' +
        '<span class="meili-gimg">' + badge +
          '<img loading="lazy" src="' + esc(thumb(h.image, 200)) + '" alt="' + esc(h.title) + '"></span>' +
        '<span class="meili-gtitle">' + title + '</span>' +
        '<span class="meili-gprice">' + priceHtml(h) + '</span></a>';
    }

    function renderPanel(q, products, total, suggestions, prodLabel) {
      var sugg = suggestions.map(function (s) {
        return '<li class="meili-ac-term" data-term="' + esc(s) + '" role="button" tabindex="0">' + esc(s) + '</li>';
      }).join('');
      var allBtn = (q && total)
        ? '<a class="meili-ac-foot" href="' + SEARCH_URL + '?q=' + encodeURIComponent(q) + '&type=product">' +
          'Afficher tous les ' + total + ' articles »</a>'
        // Empty-query FBT/related state (prodLabel set) -> link to the full
        // complementary-products page. Not shown for the "newest" fallback.
        : (!q && prodLabel && products.length
          ? '<a class="meili-ac-foot" href="' + SEARCH_URL + '?related=1">Voir tous les produits complémentaires »</a>'
          : '');
      var grid = products.length
        ? '<div class="meili-ac-grid">' + products.map(function (h, i) { return gridCard(h, i, q); }).join('') + '</div>'
        : '<div class="meili-ac-empty">Aucun résultat pour <strong>' + esc(q) + '</strong></div>';
      box.innerHTML = '<div class="meili-ac-pop">' +
        '<div class="meili-ac-terms">' +
          '<div class="meili-ac-seclabel">' + (q ? 'Suggestions' : 'Recherches populaires') + '</div>' +
          '<ul>' + sugg + '</ul>' +
        '</div>' +
        '<div class="meili-ac-prods">' +
          '<div class="meili-ac-seclabel">' + (prodLabel || 'Produits') + '</div>' + grid +
        '</div>' +
      '</div>' + allBtn; // full-width footer, pinned at the bottom
      box.querySelectorAll('.meili-ac-term').forEach(function (li) {
        li.addEventListener('mousedown', function (e) { e.preventDefault(); input.value = li.dataset.term; runNow(); input.focus(); });
      });
      // Flag the empty-query state so mobile can hide the suggestions block
      // (suggestions only appear once the shopper starts typing).
      box.classList.toggle('meili-empty-q', !q);
      activeIdx = -1;
      open();
    }

    var relatedCache = null; // { sig, hits } — related products for the current cart+quote seeds
    var PRODUCT_FIELDS = ['id', 'title', 'url', 'image', 'price', 'compareAtPrice', 'onSale', 'discountPct', 'available', 'backorder', 'deliveryDays', 'availableAfterTs'];
    var TARGET = 27; // products to fill the empty-state grid (FBT topped up with category best-sellers)

    // Round-robin a product pool across categories so the grid is a MIX (one per
    // category in turn, newest-first within each), instead of many of the same type.
    function diversifyByType(items, limit) {
      var groups = {}, order = [];
      items.forEach(function (h) {
        var t = h.productType || '—';
        if (!groups[t]) { groups[t] = []; order.push(t); }
        groups[t].push(h);
      });
      var out = [];
      for (var pass = 0; out.length < limit; pass++) {
        var added = false;
        for (var g = 0; g < order.length && out.length < limit; g++) {
          var arr = groups[order[g]];
          if (arr.length) { out.push(arr.shift()); added = true; }
        }
        if (!added) break; // all categories exhausted
      }
      return out;
    }

    // Deterministic daily rotation: same list all day, different each day.
    function daySeed() { var d = new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
    function shuffleSeeded(arr, seed) {
      var s = seed >>> 0, a = arr.slice();
      function rnd() { s = (s + 0x6D2B79F5) | 0; var t = Math.imul(s ^ (s >>> 15), 1 | s); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }
      for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var tmp = a[i]; a[i] = a[j]; a[j] = tmp; }
      return a;
    }

    // Empty-state (nothing in cart/quote): newest DISCOUNTED, in-stock products.
    // Leads with the engaging KIT deals (smart cars, Arduino kits, WeDo, MicroBit,
    // robot kits) so the store's identity shows first, then a category-diversified
    // mix of the newest markdowns with industrial-tool brands capped.
    var KIT_HANDLES = ['arduino-kit', 'kits-robotiques', 'kits-voitures', 'kits-de-robots', 'wedo', 'lego-education', 'microbit', 'bras-robotiques', 'drones-helices'];
    var LEAD_COUNT = 6;
    var TOOL_VENDORS = { TOTAL: 1, WADFOW: 1, YATO: 1, HARDEN: 1 }; // capped so tools don't dominate
    var TOOL_CAP = 2;
    function showNewest() {
      if (popularCache) { renderPanel('', popularCache, 0, POP_TERMS); return; }
      // "Discounted" here = a REAL markdown (compareAtPrice set), NOT the promo-tier
      // tags (discount_5/10/15) that the discount app applies at checkout.
      var deals = 'compareAtPrice IS NOT NULL AND available = true';
      // Price floor keeps cheap accessories (silicone cases, extension boards
      // that live in kit collections) OUT of the hero lead slots — without it
      // the small kit-deal pool pins the same accessories every day.
      var kitFilter = deals + ' AND price >= 50 AND (' + KIT_HANDLES.map(function (h) { return 'collectionHandles = "' + h + '"'; }).join(' OR ') + ')';
      var fields = PRODUCT_FIELDS.concat(['productType', 'vendor']);
      // Lead pool = ALL discounted kit deals (hero products, not recency-gated);
      // general pool = newest markdowns (createdAt:desc). Both rotated by date seed.
      Promise.all([
        request({ q: '', limit: 60, sort: ['createdAt:desc'], filter: kitFilter, attributesToRetrieve: fields }).then(function (d) { return d.hits || []; }).catch(function () { return []; }),
        request({ q: '', limit: 60, sort: ['createdAt:desc'], filter: deals, attributesToRetrieve: fields }).then(function (d) { return d.hits || []; }).catch(function () { return []; })
      ]).then(function (arr) {
        var seed = daySeed();
        var kits = shuffleSeeded(arr[0], seed);
        var all = shuffleSeeded(arr[1], (seed ^ 0x9e3779b9) >>> 0);
        if (!all.length && !kits.length) { // nothing discounted -> plain newest
          return request({ q: '', limit: TARGET, sort: ['createdAt:desc'], attributesToRetrieve: PRODUCT_FIELDS })
            .then(function (d2) { popularCache = d2.hits || []; renderPanel('', popularCache, 0, POP_TERMS); });
        }
        var seen = {}, vendorCount = {}, out = [];
        function canAdd(h) {
          var id = String(h.id); if (seen[id]) return false;
          var v = (h.vendor || '').toUpperCase();
          if (TOOL_VENDORS[v] && (vendorCount[v] || 0) >= TOOL_CAP) return false;
          return true;
        }
        function add(h) { seen[String(h.id)] = 1; var v = (h.vendor || '').toUpperCase(); vendorCount[v] = (vendorCount[v] || 0) + 1; out.push(h); }
        // 1) lead with LEAD_COUNT engaging kit deals (shuffled, NOT diversified —
        //    smart cars / robot kits are all one category, so keep them prominent)
        for (var k = 0; k < kits.length && out.length < LEAD_COUNT; k++) { if (canAdd(kits[k])) add(kits[k]); }
        // 2) fill to TARGET from the diversified general pool (tool brands capped)
        var mix = diversifyByType(all, all.length);
        for (var i = 0; i < mix.length && out.length < TARGET; i++) { if (canAdd(mix[i])) add(mix[i]); }
        popularCache = out;
        renderPanel('', popularCache, 0, POP_TERMS);
      });
    }

    // Empty-query state, in priority order:
    //   1) "Souvent achetés ensemble" — real co-purchase (frequentlyBoughtWith),
    //      aggregated across everything in cart + quote.
    //   2) "Vous pourriez aussi aimer" — same-category best-sellers (fallback when
    //      the seeds have little/no co-purchase data).
    //   3) newest products (nothing in cart/quote).
    function showPopular() {
      cartSeedIds().then(function (cart) {
        var all = cart.concat(quoteSeedIds());
        var seeds = all.filter(function (v, i) { return v && all.indexOf(v) === i; });
        if (!seeds.length) { showNewest(); return; }
        var recency = updateSeedRecency(seeds); // id -> when first added (higher = newer)
        var sig = seeds.slice().sort().join(',');
        if (relatedCache && relatedCache.sig === sig) {
          renderPanel('', relatedCache.hits, 0, POP_TERMS, relatedCache.label); return;
        }
        var finish = function (hits, label) {
          if (!hits.length) { showNewest(); return; }
          relatedCache = { sig: sig, hits: hits, label: label };
          renderPanel('', hits, 0, POP_TERMS, label);
        };
        // one lookup gets the seeds' categories AND their co-purchase partners
        request({ q: '', filter: 'id IN [' + idList(seeds) + ']', limit: seeds.length,
          attributesToRetrieve: ['id', 'productType', 'frequentlyBoughtWith'] })
          .then(function (s) {
            var seedHits = s.hits || [];
            // Same-category best-sellers — used to TOP UP the grid to TARGET when
            // there aren't enough co-purchase matches (a single cart item only has
            // ~10 partners, which looked sparse).
            function categoryHits() {
              var types = {};
              seedHits.forEach(function (h) { if (h.productType) types[h.productType] = 1; });
              var typeKeys = Object.keys(types);
              if (!typeKeys.length) return Promise.resolve([]);
              var tf = '(' + typeKeys.map(function (t) { return 'productType = "' + t.replace(/"/g, '\\"') + '"'; }).join(' OR ') + ')';
              return request({ q: '', limit: TARGET, sort: ['popularity:desc'],
                filter: tf + ' AND available = true AND id NOT IN [' + idList(seeds) + ']',
                attributesToRetrieve: PRODUCT_FIELDS })
                .then(function (rel) { return rel.hits || []; }).catch(function () { return []; });
            }
            // Combine co-purchase partners from ALL cart/quote products, deduped,
            // ordered by SEED RECENCY: the most recently added product's
            // frequently-bought-together items lead, then older products'.
            var byRecency = seedHits.slice().sort(function (a, b) {
              return (recency[String(b.id)] || 0) - (recency[String(a.id)] || 0);
            });
            var orderedIds = [], picked = {};
            byRecency.forEach(function (h) {
              (h.frequentlyBoughtWith || []).forEach(function (id) {
                id = String(id);
                if (seeds.indexOf(id) >= 0 || picked[id]) return; // skip seeds + duplicates
                picked[id] = 1; orderedIds.push(id);
              });
            });
            var rank = {}; orderedIds.forEach(function (id, i) { rank[id] = i; });
            var query = orderedIds.slice(0, 40); // enough to fill TARGET after out-of-stock drops
            var fbtHits = query.length
              ? request({ q: '', limit: query.length, filter: 'id IN [' + idList(query) + '] AND available = true',
                  attributesToRetrieve: PRODUCT_FIELDS })
                  .then(function (r) { return (r.hits || []).sort(function (a, b) { return (rank[String(a.id)] || 0) - (rank[String(b.id)] || 0); }); })
                  .catch(function () { return []; })
              : Promise.resolve([]);
            fbtHits.then(function (fbt) {
              var leadIsFbt = fbt.length >= 4; // enough real co-purchase to headline it
              if (fbt.length >= TARGET) { finish(fbt.slice(0, TARGET), 'Souvent achetés ensemble'); return; }
              // Fill remaining slots with category best-sellers (dedup by id).
              categoryHits().then(function (cat) {
                var seen = {};
                fbt.forEach(function (h) { seen[String(h.id)] = 1; });
                var merged = fbt.slice();
                cat.forEach(function (h) { var id = String(h.id); if (!seen[id]) { seen[id] = 1; merged.push(h); } });
                finish(merged.slice(0, TARGET), leadIsFbt ? 'Souvent achetés ensemble' : 'Vous pourriez aussi aimer');
              });
            });
          }).catch(showNewest);
      });
    }

    function doSearch(q) {
      lastQ = q;
      request({
        q: q, limit: 25,
        matchingStrategy: 'all', // require ALL typed words -> precise results
        attributesToHighlight: ['title'],
        facets: ['productType'],
        attributesToRetrieve: ['id', 'title', 'url', 'image', 'price', 'compareAtPrice', 'onSale', 'discountPct', 'available', 'backorder', 'deliveryDays', 'availableAfterTs']
      }).then(function (data) {
        if (input.value.trim() !== lastQ) return;
        hits = data.hits || [];
        lastTotal = data.estimatedTotalHits || 0;
        logSearch();
        // Suggestions = query completions (corrected/completed from titles) first,
        // then relevant product categories.
        var comps = completions(q, hits);
        var dist = (data.facetDistribution && data.facetDistribution.productType) || {};
        var qn = norm(q);
        var cats = Object.keys(dist).sort(function (a, b) {
          var am = norm(a).indexOf(qn) >= 0 ? 0 : 1, bm = norm(b).indexOf(qn) >= 0 ? 0 : 1;
          if (am !== bm) return am - bm;
          return dist[b] - dist[a];
        }).slice(0, 4);
        var suggestions = [], seen = {};
        comps.concat(cats).forEach(function (s) { var k = norm(s); if (!seen[k]) { seen[k] = 1; suggestions.push(s); } });
        if (!suggestions.length) suggestions = hits.length ? [q] : POP_TERMS;
        renderPanel(q, hits, data.estimatedTotalHits || 0, suggestions.slice(0, 6));
      }).catch(function () { close(); });
    }

    function runNow() { var q = input.value.trim(); if (q.length < 2) showPopular(); else doSearch(q); }
    var run = debounce(runNow, 160);

    input.addEventListener('input', run);
    // Open immediately on focus: popular content when empty, live results otherwise.
    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= 2) { hits.length ? open() : doSearch(q); }
      else showPopular();
    });

    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('.meili-gcard');
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); paint(items); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); paint(items); }
      else if (e.key === 'Enter') {
        if (activeIdx >= 0 && items[activeIdx]) { e.preventDefault(); window.location.href = items[activeIdx].getAttribute('href'); }
      } else if (e.key === 'Escape') { close(); }
    });
    function paint(items) {
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIdx); });
      if (activeIdx >= 0 && items[activeIdx]) items[activeIdx].scrollIntoView({ block: 'nearest' });
    }

    document.addEventListener('click', function (e) {
      if (!box.contains(e.target) && e.target !== input) close();
    });
  }

  /* ==================================================================
   * 2) RESULTS PAGE
   * ================================================================== */
  function initResultsPage(mount) {
    var PAGE = 24;
    var RELATED = new URLSearchParams(location.search).get('related') === '1';
    var state = {
      q: mount.dataset.q || new URLSearchParams(location.search).get('q') || '',
      sort: '', offset: 0,
      onSale: false, available: false, comingSoon: false,
      productType: {}, vendor: {},
      // "produits complémentaires" mode: co-purchase lead pinned, then same-category
      // best-sellers with infinite scroll.
      related: RELATED, relatedFbtIds: [], relatedRank: {}, relatedTypes: [], relatedSeeds: [],
      relatedShown: {}, relatedCatTotal: 0
    };
    var loadedHits = [], total = 0, facetDist = {}, logged = false;

    mount.innerHTML =
      '<button class="meili-mobile-filter-btn" id="meili-mfilter">☰ Filtres</button>' +
      '<div class="meili-layout">' +
        '<aside class="meili-facets" id="meili-facets"></aside>' +
        '<div class="meili-main">' +
          '<div class="meili-toolbar">' +
            '<div class="meili-count" id="meili-count"></div>' +
            '<select class="meili-sort" id="meili-sort">' +
              '<option value="">Pertinence</option>' +
              '<option value="price:asc">Prix croissant</option>' +
              '<option value="price:desc">Prix décroissant</option>' +
              '<option value="createdAt:desc">Nouveautés</option>' +
            '</select>' +
          '</div>' +
          '<div class="cata-product cp-grid" id="meili-grid"></div>' +
          '<div class="meili-sentinel" id="meili-sentinel"></div>' +
        '</div>' +
      '</div>';

    var elGrid = mount.querySelector('#meili-grid');
    var elCount = mount.querySelector('#meili-count');
    var elFacets = mount.querySelector('#meili-facets');
    var elSentinel = mount.querySelector('#meili-sentinel');
    var loading = false;

    // Auto-load the next page when the sentinel nears the viewport (infinite scroll).
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) maybeLoadMore();
    }, { rootMargin: '800px' });
    io.observe(elSentinel);
    function maybeLoadMore() {
      if (loading) return;
      if (state.related) { if (state.offset + PAGE >= state.relatedCatTotal) return; }
      else if (loadedHits.length >= total) return;
      state.offset += PAGE;
      query(true);
    }

    mount.querySelector('#meili-sort').addEventListener('change', function () {
      state.sort = this.value; reset();
    });
    mount.querySelector('#meili-mfilter').addEventListener('click', function () {
      elFacets.classList.add('is-open');
    });

    function buildFilter(exclude) {
      var parts = [];
      if (state.related) {
        // Base pool = same categories as the cart/quote, excluding what's in them.
        if (state.relatedTypes.length) parts.push('(' + state.relatedTypes.map(function (t) { return 'productType = "' + t.replace(/"/g, '\\"') + '"'; }).join(' OR ') + ')');
        if (state.relatedSeeds.length) parts.push('id NOT IN [' + idList(state.relatedSeeds) + ']');
      }
      if (state.available) parts.push('available = true AND backorder = false');
      if (state.onSale) parts.push('onSale = true');
      if (state.comingSoon) parts.push('availableAfterTs > ' + Date.now());
      if (exclude !== 'productType') { var p = orGroup('productType', state.productType); if (p) parts.push(p); }
      if (exclude !== 'vendor') { var v = orGroup('vendor', state.vendor); if (v) parts.push(v); }
      return parts.join(' AND ');
    }
    function orGroup(field, sel) {
      var keys = Object.keys(sel).filter(function (k) { return sel[k]; });
      if (!keys.length) return '';
      return '(' + keys.map(function (k) { return field + ' = "' + k.replace(/"/g, '\\"') + '"'; }).join(' OR ') + ')';
    }

    var RESULT_FIELDS = ['id', 'title', 'url', 'image', 'price', 'compareAtPrice', 'onSale', 'discountPct', 'available', 'backorder', 'deliveryDays', 'availableAfterTs', 'vendor'];

    function query(append) {
      if (state.related) return queryRelated(append);
      var body = {
        q: state.q,
        offset: append ? state.offset : 0,
        limit: PAGE,
        matchingStrategy: 'all', // require ALL typed words -> precise results
        filter: buildFilter(),
        facets: ['productType', 'vendor', 'onSale', 'available'],
        attributesToRetrieve: RESULT_FIELDS
      };
      if (state.sort) body.sort = [state.sort];
      loading = true;
      elGrid.style.opacity = append ? '1' : '0.4';
      request(body).then(function (data) {
        total = data.estimatedTotalHits || 0;
        facetDist = data.facetDistribution || {};
        if (!append && !logged) { logged = true; track({ type: 'search', query: state.q, results: total, source: 'results' }); }
        if (append) { loadedHits = loadedHits.concat(data.hits); }
        else { loadedHits = data.hits; state.offset = 0; }
        renderGrid(); renderFacets(); renderCount();
        elGrid.style.opacity = '1';
        loading = false;
        updateSentinel();
        if (loadedHits.length < total) {
          var r = elSentinel.getBoundingClientRect();
          if (r.top < (window.innerHeight || 800) + 800) maybeLoadMore();
        }
      });
    }

    // Related mode: page 1 pins the co-purchase lead, then same-category
    // best-sellers stream in with infinite scroll (each scroll = the next page).
    function queryRelated(append) {
      if (!append) { state.offset = 0; state.relatedShown = {}; loadedHits = []; }
      var catBody = {
        q: '', offset: append ? state.offset : 0, limit: PAGE,
        filter: buildFilter(),
        facets: ['productType', 'vendor', 'onSale', 'available'],
        sort: [state.sort || 'popularity:desc'],
        attributesToRetrieve: RESULT_FIELDS
      };
      // Co-purchase lead: fetched once (first page), only when not explicitly sorted.
      var leadReq = (!append && !state.sort && state.relatedFbtIds.length)
        ? request({ q: '', limit: state.relatedFbtIds.length,
            filter: 'id IN [' + idList(state.relatedFbtIds) + ']' + (state.available ? ' AND available = true' : '') + (state.onSale ? ' AND onSale = true' : ''),
            attributesToRetrieve: RESULT_FIELDS })
            .then(function (r) { return (r.hits || []).sort(function (a, b) { return (state.relatedRank[String(a.id)] || 0) - (state.relatedRank[String(b.id)] || 0); }); })
            .catch(function () { return []; })
        : Promise.resolve([]);
      // Only query the category pool when we actually have seed categories,
      // otherwise the filter would degrade to "all products".
      var catReq = state.relatedTypes.length
        ? request(catBody)
        : Promise.resolve({ hits: [], estimatedTotalHits: 0, facetDistribution: {} });
      loading = true;
      elGrid.style.opacity = append ? '1' : '0.4';
      Promise.all([leadReq, catReq]).then(function (arr) {
        var lead = arr[0], data = arr[1];
        state.relatedCatTotal = data.estimatedTotalHits || 0;
        facetDist = data.facetDistribution || {};
        if (!append && !logged) { logged = true; track({ type: 'search', query: '[complémentaires]', results: state.relatedCatTotal, source: 'results' }); }
        function add(h) { var id = String(h.id); if (!state.relatedShown[id]) { state.relatedShown[id] = 1; loadedHits.push(h); } }
        lead.forEach(add);
        (data.hits || []).forEach(add);
        total = loadedHits.length + Math.max(0, state.relatedCatTotal - (state.offset + PAGE)); // shown + still-to-come
        renderGrid(); renderFacets(); renderCount();
        elGrid.style.opacity = '1';
        loading = false;
        updateSentinel();
        if (state.offset + PAGE < state.relatedCatTotal) {
          var r = elSentinel.getBoundingClientRect();
          if (r.top < (window.innerHeight || 800) + 800) maybeLoadMore();
        }
      });
    }
    function reset() { state.offset = 0; query(false); }

    function card(h, i) {
      var badge = (h.onSale && h.discountPct)
        ? '<span class="product-label"><span class="label-sale type-percent"><span class="sale-text">-' + h.discountPct + '<sup>%</sup></span></span></span>' : '';
      var price = (h.onSale && h.compareAtPrice
          ? '<span class="price-sale">' + money(h.price) + '</span> <span class="price-compare">' + money(h.compareAtPrice) + '</span>'
          : '<span class="price">' + money(h.price) + '</span>');
      price += statusHtml(h);
      var dataAttrs = ' data-pid="' + esc(h.id) + '" data-title="' + esc(h.title) + '" data-price="' + (h.price == null ? '' : h.price) +
        '" data-pos="' + ((i || 0) + 1) + '" data-q="' + esc(state.q) + '" data-src="results"';
      return '<div class="product-grid-item"><div class="product-wrapper">' +
        '<div class="product-head"><div class="product-image"><div class="featured-img">' +
          '<a href="' + esc(h.url) + '"' + dataAttrs + '>' +
            imgBox(h.image, h.title, 'featured-image front') +
            badge +
          '</a>' +
        '</div></div></div>' +
        '<div class="product-content"><div class="pc-inner">' +
          '<div class="product-group-vendor-name">' +
            (h.vendor ? '<div class="product-vendor">' + esc(h.vendor) + '</div>' : '') +
            '<h5 class="product-name"><a href="' + esc(h.url) + '"' + dataAttrs + '>' + esc(h.title) + '</a></h5>' +
          '</div>' +
          '<div class="price-cart-wrapper"><div class="product-price notranslate">' + price + '</div></div>' +
        '</div></div>' +
      '</div></div>';
    }

    function renderGrid() {
      var ex = mount.querySelector('.meili-empty'); if (ex) ex.remove();
      if (!loadedHits.length) {
        elGrid.innerHTML = '';
        var msg = state.related
          ? '<div class="meili-empty"><h4>Aucun produit complémentaire</h4><p>Ajoutez des articles à votre panier ou à votre devis pour voir des suggestions.</p></div>'
          : '<div class="meili-empty"><h4>Aucun résultat pour « ' + esc(state.q) + ' »</h4><p>Essayez un autre terme ou vérifiez l\'orthographe.</p></div>';
        elGrid.insertAdjacentHTML('beforebegin', msg);
        return;
      }
      elGrid.innerHTML = loadedHits.map(card).join('');
    }
    function renderCount() {
      if (state.related) {
        elCount.innerHTML = '<strong>' + total + '</strong> produit' + (total > 1 ? 's' : '') + ' complémentaire' + (total > 1 ? 's' : '');
        return;
      }
      elCount.innerHTML = '<strong>' + total + '</strong> résultat' + (total > 1 ? 's' : '') +
        (state.q ? ' pour « ' + esc(state.q) + ' »' : '');
    }
    function updateSentinel() {
      var more = state.related ? (state.offset + PAGE < state.relatedCatTotal) : (loadedHits.length < total);
      elSentinel.innerHTML = more ? '<div class="meili-loading">Chargement…</div>' : '';
    }
    function renderFacets() {
      var html = '<button class="meili-facets-close" id="meili-fclose">×</button>';
      html += '<div class="meili-facet-group"><h4>Disponibilité</h4><div class="meili-toggles">' +
        '<span class="meili-chip ' + (state.available ? 'is-on' : '') + '" data-toggle="available">En stock</span>' +
        '<span class="meili-chip ' + (state.onSale ? 'is-on' : '') + '" data-toggle="onSale">En promo</span>' +
        '<span class="meili-chip ' + (state.comingSoon ? 'is-on' : '') + '" data-toggle="comingSoon">Bientôt disponible</span>' +
        '</div></div>';
      html += facetGroup('Catégorie', 'productType', state.productType);
      html += facetGroup('Marque', 'vendor', state.vendor);
      elFacets.innerHTML = html;

      elFacets.querySelector('#meili-fclose').onclick = function () { elFacets.classList.remove('is-open'); };
      elFacets.querySelectorAll('[data-toggle]').forEach(function (chip) {
        chip.onclick = function () {
          var k = chip.dataset.toggle; state[k] = !state[k];
          if (state[k]) { var chipLabels = { available: 'En stock', onSale: 'En promo', comingSoon: 'Bientôt disponible' }; track({ type: 'filter', filterName: 'Disponibilité', filterValue: chipLabels[k] || k }); }
          reset();
        };
      });
      elFacets.querySelectorAll('[data-facet]').forEach(function (row) {
        row.onchange = function () {
          var f = row.dataset.facet, val = row.dataset.val;
          state[f][val] = row.checked;
          if (row.checked) track({ type: 'filter', filterName: f === 'productType' ? 'Catégorie' : 'Marque', filterValue: val });
          reset();
        };
      });
      elFacets.querySelectorAll('.meili-facet-more').forEach(function (btn) {
        btn.onclick = function () { btn.previousElementSibling.querySelectorAll('.is-hidden').forEach(function (n) { n.classList.remove('is-hidden'); }); btn.remove(); };
      });
    }
    function facetGroup(label, field, sel) {
      var dist = facetDist[field] || {};
      var keys = Object.keys(dist).sort(function (a, b) { return dist[b] - dist[a]; });
      // keep any selected values even if absent from current distribution
      Object.keys(sel).forEach(function (k) { if (sel[k] && keys.indexOf(k) < 0) keys.unshift(k); });
      if (!keys.length) return '';
      var rows = keys.map(function (k, i) {
        return '<label class="meili-facet ' + (i >= 8 ? 'is-hidden' : '') + '"' + (i >= 8 ? ' style="display:none"' : '') + '>' +
          '<input type="checkbox" data-facet="' + field + '" data-val="' + esc(k) + '"' + (sel[k] ? ' checked' : '') + '>' +
          '<span>' + esc(k) + '</span><span class="cnt">' + (dist[k] || '') + '</span></label>';
      }).join('');
      var more = keys.length > 8 ? '<button class="meili-facet-more">+ voir plus</button>' : '';
      return '<div class="meili-facet-group"><h4>' + label + '</h4><div>' + rows + '</div>' + more + '</div>';
    }

    // Reveal hidden facet rows properly (class + inline style).
    var style = document.createElement('style');
    style.textContent = '.meili-facet.is-hidden{display:none}' +
      // The facets ✕ is only for the mobile drawer — hide it on desktop.
      '.meili-facets-close{display:none}@media (max-width:991px){.meili-facets-close{display:block}}';
    document.head.appendChild(style);

    if (state.related) {
      // Resolve the co-purchase lead + seed categories from the current cart+quote,
      // then run the paginated faceted query (infinite scroll through categories).
      elCount.innerHTML = 'Chargement des suggestions…';
      relatedContext().then(function (res) {
        state.relatedFbtIds = res.fbtIds; state.relatedRank = res.rank;
        state.relatedSeeds = res.seeds; state.relatedTypes = res.types;
        if (!res.seeds.length || (!res.types.length && !res.fbtIds.length)) {
          total = 0; loadedHits = []; renderGrid(); renderCount(); return;
        }
        query(false);
      });
    } else {
      query(false);
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    ['#bc-product-search', '#bc-product-mobile-search'].forEach(function (sel) {
      initAutocomplete(document.querySelector(sel));
    });
    var mount = document.getElementById('meili-search-app');
    if (mount) {
      var fb = document.getElementById('meili-native-fallback');
      if (fb) fb.style.display = 'none';
      initResultsPage(mount);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
